module.exports = __webpack_public_path__ + "img/autoCar.d9a67b89.png";